export const sizeSidebar = {
    with: "300px"
}